import Users from "../components/Users";
import TopNav from "../components/TopNav";
import Sidebar from "../components/SideNav";
import Footer from "../components/Footer";
const UserPage = () => {
  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100vh" }}>
      <div className="sticky-top z-3">
        <TopNav />
      </div>
      <div className="d-flex flex-grow-1 overflow-hidden">
        <aside
          className=""
          style={{
            // width: "240px",
            position: "sticky",
            height: "calc(100vh - 120px)",
          }}
        >
          <Sidebar />
        </aside>
        <main className="w-100 overflow-auto w-25">
          <div className="header bg-theme-light pb-9 p-4">
            <div className="container-fluid">
              <div className="header-body">
                <div className="headnumText justify-content-between">
                  <div className="pageTitleWrap">
                    <h5>User List</h5>
                    {/* <p>Lorem ipsum is placeholder text commonly used</p> */}
                  </div>
                </div>
              </div>
            </div>
            <Users />
          </div>
        </main>
      </div>
      <div className="sticky-bottom z-3">
        <Footer />
      </div>
    </div>
  );
};
export default UserPage;
